import constants from 'constants/index'

const getMimeTypeFromExtension = (filename) => {
  const extension = filename
    .substring(filename.lastIndexOf('.') + 1)
    .toLowerCase()

  return (
    constants.validations.MIME_TYP_VALIDATION[extension] ||
    constants.validations.UNKNOWN_FILE_MIME_TYPE
  )
}

export default getMimeTypeFromExtension
